import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "carousel-track" }
const _hoisted_2 = { class: "meta absolute left-0 right-0 bottom-0 pl-2 pr-2" }

import { ref, onMounted, watch } from 'vue';
import useAirtable from "@/composables/useAirtable";


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryComponent',
  async setup(__props) {

let __temp: any, __restore: any

const { records, fetchRecords } = useAirtable();
;(
  ([__temp,__restore] = _withAsyncContext(() => fetchRecords())),
  await __temp,
  __restore()
);

const displayedRecords = ref(records.value.slice(0, 50));
const carouselRef = ref<HTMLElement | null>(null);

// Recalculate displayedRecords when records updates
watch(records, () => {
  displayedRecords.value = records.value.slice(0, 50);
});

onMounted(() => {
  const carousel = carouselRef.value;
  if (carousel) {
    // Repeat the images to ensure continuous scrolling effect
    displayedRecords.value = [...displayedRecords.value, ...displayedRecords.value];
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "carousel overflow-hidden relative w-full py-12",
    ref_key: "carouselRef",
    ref: carouselRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedRecords.value, (prisoner, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "carousel-slide inline-block w-36 h-56 bg-cover bg-center rounded-lg mx-2 relative",
          key: index,
          style: _normalizeStyle({ backgroundImage: `url(${prisoner.Photo})` })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(prisoner.name), 1)
          ])
        ], 4))
      }), 128))
    ])
  ], 512))
}
}

})